module.exports = __webpack_public_path__ + "images/help/icon-twr60@2x-9c84e160ab291fd95b05aa3a94e61dd2.png";